const match = window.location.pathname.match(/[^\/]+/);
const shopId = match ? match[0] : "";

export function getRoutePrefix() {
  return shopId;
}
